(() => {
  const initialize = (scope = document) => {
    const root = scope.querySelector('[data-bsn-search]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    if (root.dataset.performed === 'true' && root.dataset.productOnly !== 'true') {
      const url = new URL(window.location.href);
      url.searchParams.set('type', 'product');
      window.location.replace(url.toString());
      return;
    }
    const pageSearch = root.querySelector('[data-page-search]');
    pageSearch?.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      pageSearch.close();
      pageSearch.querySelector('input[name="q"]')?.blur();
    });
    const buttons = [...root.querySelectorAll('[data-result-filter]')];
    const items = [...root.querySelectorAll('[data-result-kind]')];
    const groups = [...root.querySelectorAll('[data-search-group]')];
    const jump = root.querySelector('[data-search-jump]');
    const empty = root.querySelector('[data-filter-empty]');
    const status = root.querySelector('[data-search-filter-status]');
    let filter = 'all';
    const controls = root.querySelector('[data-search-controls]');
    if (controls && !items.length) controls.hidden = true;
    buttons.forEach(button => {
      const kind = button.dataset.resultFilter;
      const count = items.filter(item => item.dataset.resultKind === kind).length;
      const countNode = button.querySelector('[data-filter-count]');
      if (countNode) countNode.textContent = `(${count})`;
      if (kind !== 'all' && !count) button.hidden = true;
    });
    root.querySelector('[data-search-chat]')?.addEventListener('click', () => {
      const openChat = () => {
        if (typeof window.tidioChatApi?.open !== 'function') return false;
        if (typeof window.tidioChatApi.show === 'function') window.tidioChatApi.show();
        window.tidioChatApi.open();
        return true;
      };
      if (openChat() || root.dataset.chatWaiting) return;
      root.dataset.chatWaiting = 'true';
      document.addEventListener('tidioChat-ready', () => {
        delete root.dataset.chatWaiting;
        openChat();
      }, { once: true });
    });
    const update = () => {
      let visible = 0;
      items.forEach(item => {
        const kind = item.dataset.resultKind;
        const shown = filter === 'all' || kind === filter;
        item.hidden = !shown;
        const wrapper = item.closest('[data-product-item]');
        if (wrapper) wrapper.hidden = !shown;
        if (shown) visible++;
      });
      groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-result-kind]')].some(item => !item.hidden); });
      buttons.forEach(button => {
        const active = button.dataset.resultFilter === filter;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('button--secondary', !active);
      });
      if (empty) empty.hidden = visible > 0 || items.length === 0;
      if (status) status.textContent = `${visible} ${status.dataset.countLabel}`;
      if (jump) {
        jump.replaceChildren();
        groups.filter(group => !group.hidden).forEach(group => {
          const link = document.createElement('a');
          link.href = `#${group.id}`;
          link.textContent = group.dataset.groupTitle;
          jump.append(link);
        });
        jump.hidden = jump.children.length < 2;
      }
    };
    buttons.forEach(button => button.addEventListener('click', () => { filter = button.dataset.resultFilter; update(); }));
    root.querySelector('[data-clear-filters]')?.addEventListener('click', () => { filter = 'all'; update(); });
    update();
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
